module.exports = __webpack_public_path__ + "media/images/icons/vehicle-storage-medium-10x20-2bce7641c7d2fd2173747c21ff52b3f5.png";